// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1c-0";
export var spinnerContainer = "_1c-1";